import { render, staticRenderFns } from "./partyGroupConfigAdd.vue?vue&type=template&id=03d99a5e&scoped=true"
import script from "./partyGroupConfigAdd.vue?vue&type=script&lang=js"
export * from "./partyGroupConfigAdd.vue?vue&type=script&lang=js"
import style0 from "./partyGroupConfigAdd.vue?vue&type=style&index=0&id=03d99a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d99a5e",
  null
  
)

export default component.exports